import React from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import { Notification } from "../../models/notification";

interface Props {
  notification: Notification
  link: string;
  icon?: React.ReactNode
}

const LinkNotif: React.FC<Props> = ({ notification, link, icon }) => {
  const { t } = useTranslation("common");

  return (
    <div className="flex flex-col gap-1">
      <div>
        <Link href={link} className="flex space-x-3 items-center text-blue-500 hover:text-blue-600">
          <div>{icon}</div>
          <div>
            <>
              {t(
                `notifications.${notification.notificationType}.title`,
                JSON.parse(notification.metadata),
              )}
            </>
          </div>
        </Link>
      </div>
      <span className="text-gray-700 text-sm">
        <>
          {t(
            `notifications.${notification.notificationType}.body`,
            JSON.parse(notification.metadata),
          )}
        </>
      </span>
    </div>
  );
};

export default LinkNotif;
